import {initialize} from 'linksoft';
import initializer, {initSelect2} from './select2';

initialize.register(initializer);

export default initSelect2;


// WEBPACK FOOTER //
// ./node_modules/linksoft-select2/src/index.js